import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, NewsletterMeta } from "../api";
import { useAuth } from "../auth";

function fmt(ts: number | null): string {
  if (!ts) return "";
  return new Date(ts * 1000).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });
}

export default function Home() {
  const { can } = useAuth();
  const [issues, setIssues] = useState<NewsletterMeta[] | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    api
      .listNewsletters()
      .then((list) => setIssues(list.filter((n) => n.status === "published")))
      .catch((e) => setErr(e.message));
  }, []);

  return (
    <div className="page-wrap">
      <header style={{ textAlign: "center", marginBottom: 36 }}>
        <div style={{ fontFamily: "'Cinzel',serif", fontWeight: 900, fontSize: 52, letterSpacing: ".02em", color: "var(--ink)" }}>
          The Archive
        </div>
        <div className="mono" style={{ marginTop: 10, fontSize: 11, textTransform: "uppercase", letterSpacing: ".16em", color: "var(--muted)" }}>
          Published Dispatches of the Imperium
        </div>
      </header>

      {err && <p style={{ color: "var(--accent)" }}>{err}</p>}
      {!issues && !err && <p className="mono" style={{ color: "var(--muted)", fontSize: 12 }}>Loading issues…</p>}

      {issues && issues.length === 0 && (
        <p style={{ color: "var(--muted)", textAlign: "center" }}>
          No issues have been published yet.
          {can("editor") && (
            <>
              {" "}
              <Link to="/newsletters">Assemble one →</Link>
            </>
          )}
        </p>
      )}

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(300px,1fr))", gap: 18 }}>
        {issues?.map((n) => (
          <Link
            key={n.id}
            to={`/read/${n.slug}`}
            style={{ display: "block", background: "var(--paper)", border: "1px solid var(--rule2)", padding: "22px 24px", color: "var(--ink)" }}
          >
            <div style={{ fontFamily: "'Zilla Slab',sans-serif", fontWeight: 700, fontSize: 22, lineHeight: 1.15 }}>{n.title}</div>
            <div className="mono" style={{ marginTop: 10, fontSize: 10.5, textTransform: "uppercase", letterSpacing: ".1em", color: "var(--gold)" }}>
              {fmt(n.publishedAt)}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
